import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { DzCourseHeader } from '../1_home/DZ_Heading';
import { useNavigate } from 'react-router-dom';

const Component = ({ greyBackground, data }) => {
  // console.log('data: '+JSON.stringify(data))
  // const [data, setData] = useState()
  const navigate = useNavigate();
  return (
    (<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', px: 4, backgroundColor: greyBackground ? '#F0F0F0' : 'white' }}>

      <DzCourseHeader text={data.courseName} />
      <Box
        sx={{ width: '80%', height: 'auto', marginBottom: 2, padding: 2, display: 'flex', flexDirection: { xs: 'column', lg: 'row', sm: 'column', md: 'row' }, alignItems: 'center', justifyContent: 'center', backgroundColor: !greyBackground ? '#F0F0F0' : 'white', borderRadius: '12px' }}
      >
        <Box sx={{ width: '80%', height: '80%' }}>
          <img width='100%' alt='unknown' height='200%' src={`${data.image}`}></img>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 3 }}>
          <Typography variant="body1" paragraph sx={{ fontSize: '16px' }}>
            {data.description}
          </Typography>
          {/* <Button variant="contained" color="primary" sx={{marginTop: 2, fontSize: '15px', width: '90px', height: '30px'}} onClick={() => { data.longDescription ?
    navigate('/offerings/books/'+data.courseName.replace(/\s+/g, '').toLowerCase()) : navigate(data.link);
  }}>
                    {'Explore'}
                </Button> */}
          <Button variant="contained" color="primary" sx={{ marginTop: 2, fontSize: '15px', width: '90px', height: '30px' }} onClick={() => {
            navigate('/offerings/books/' + data.courseName.replace(/\s+/g, '').toLowerCase());
          }}>
            {'Explore'}
          </Button>
        </Box>
      </Box>
    </Box>)
  );
};

export default Component;